import axios from 'common/interceptor/app.interceptor';
import { repsonseErrorInterceptor, requestInterceptor } from 'common/interceptor/app.interceptor';
import appConfig from 'config/config';

let axiosInstance = axios.create({
  baseURL: appConfig.apiBaseUrl
});

axiosInstance.interceptors.response.use((resp) => {
  if (!resp?.data?.success) {
    repsonseErrorInterceptor({ ...resp, response: { request: resp?.request, responseURL: resp?.config?.url, status: 500 }, apiInternalError: true }, false);
  }
  return resp;
}, repsonseErrorInterceptor);

export default axiosInstance;
